<template>
    <v-container max-width="100%" style="margin-top: 2%">
        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" sm="6" md="2">
                        <v-datetime-picker
                            :label="$t('datetime.startDate')"
                            v-model="dti"
                            :time-picker-props="timeProps"
                            :text-field-props="textFieldProps"
                            :date-picker-props="dtiProps"
                            time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')"
                        >
                            <template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
                            <template slot="timeIcon"><v-icon>mdi-clock</v-icon></template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-datetime-picker
                            :label="$t('datetime.finalDate')"
                            v-model="dtf"
                            :time-picker-props="timeProps"
                            :text-field-props="textFieldProps"
                            :date-picker-props="dtfProps"
                            time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')"
                        >
                            <template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
                            <template slot="timeIcon"><v-icon>mdi-clock</v-icon></template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field
                            v-model="nomeDestinoFiltro"
                            :label="$t('routingHistoryTimeline.filters.destination')"
                            clearable
                        />
                    </v-col>
                    <v-col cols="12" sm="1" md="1" class="d-flex align-center justify-end">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    fab
                                    color="primary darken-1"
                                    class="white--text"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="populaRelatorio"
                                >
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <MerusDataTable
            :headers="tableHeaders"
            :items="items"
            :loading="loading"
            :default-multi-sort="defaultSort"
            :server-items-length="totalItems"
            :items-per-page="numberOfRows"
            :items-per-page-last-option="itemsPerPageLastOption"
            :server-sort-by="serverSortBy"
            :server-sort-desc="serverSortDesc"
            :loading-text="$t('routingHistoryTimeline.loading')"
            cod-tabela="RELHISTORICOROTEIRIZACAO"
            @update:headers="headers = $event"
            @update:options="onTableOptions"
            @update:filters="onFiltersUpdate"
        >
            <template v-slot:toolbar>
                <CadastroToolbar
                    :title="$t('routingHistoryTimeline.title')"
                    :token="token"
                    :items="items"
                    :load-items-for-export="loadItemsForExport"
                    csv-title="historicoroteirizacao"
                    :pdf-title="$t('routingHistoryTimeline.title')"
                    :pdf-headers="tableHeaders"
                    pdf-filename="historicoroteirizacao"
                    hide-search
                />
            </template>
            <template v-slot:item.ultimo_tipo_evento_extenso="{ item }">
                <v-chip x-small label :color="timelineColor(item.ultimo_tipo_evento)" dark>
                    {{ item.ultimo_tipo_evento_extenso }}
                </v-chip>
            </template>
            <template v-slot:item.km_total="{ item }">
                {{ formatKm(item.km_total) }}
            </template>
            <template v-slot:item.custo_total="{ item }">
                {{ formatMoney(item.custo_total) }}
            </template>
            <template v-slot:item.custo_motoristas_total="{ item }">
                {{ item.custo_motoristas_total != null ? formatMoney(item.custo_motoristas_total) : '—' }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn icon small color="primary" @click="openDetail(item)">
                    <v-icon small>mdi-timeline-text-outline</v-icon>
                </v-btn>
            </template>
        </MerusDataTable>

        <v-dialog v-model="detailShow" max-width="960" scrollable>
            <v-card v-if="detailShow" class="historico-detalhe-card">
                <v-card-title>
                    {{ $t('routingHistoryTimeline.detailTitle') }}
                    <v-spacer />
                    <v-btn
                        v-if="detailTab === 0 && compareSelection.length === 2"
                        color="primary"
                        dark
                        small
                        class="mr-2"
                        :loading="compareLoading"
                        @click="openCompare"
                    >
                        <v-icon left small>mdi-compare</v-icon>
                        {{ $t('routingHistoryTimeline.compare.action') }}
                    </v-btn>
                    <v-btn icon @click="closeDetail"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-subtitle v-if="selectedSession">
                    {{ selectedSession.nome_destino || '—' }}
                    <span v-if="selectedSession.qtd_eventos != null" class="ml-2">
                        · {{ $t('routingHistoryTimeline.eventCountLabel', { count: selectedSession.qtd_eventos }) }}
                    </span>
                </v-card-subtitle>
                <v-tabs v-model="detailTab" grow background-color="grey lighten-4">
                    <v-tab>
                        {{ isPassengerRegistrySession
                            ? $t('routingHistoryTimeline.passengerRegistry.eventsTab')
                            : $t('routingHistoryTimeline.tabs.routing') }}
                    </v-tab>
                    <v-tab v-if="!isPassengerRegistrySession">
                        {{ $t('routingHistoryTimeline.tabs.people') }}
                        <v-chip v-if="peopleEventTotal" x-small color="primary" dark class="ml-2">
                            {{ peopleEventTotal }}
                        </v-chip>
                    </v-tab>
                </v-tabs>
                <v-card-text v-show="detailTab === 0" class="historico-eventos-content">
                    <v-progress-linear v-if="detailLoading" indeterminate class="mb-4" />
                    <template v-else-if="!detailRows.length">
                        <div class="text-body-2 text--secondary">
                            {{ $t('routingHistoryTimeline.emptyTimeline') }}
                        </div>
                    </template>
                    <template v-else>
                        <div class="text-subtitle-2 mb-1">{{ $t('routingHistoryTimeline.timeline') }}</div>
                        <div v-if="!isPassengerRegistrySession" class="text-caption text--secondary mb-2">
                            {{ $t('routingHistoryTimeline.compare.hint') }}
                        </div>
                        <div v-if="compareSelection.length" class="mb-3 d-flex align-center flex-wrap">
                            <v-chip
                                v-for="(sel, idx) in compareSelection"
                                :key="sel.id_historico_roteirizacao"
                                small
                                class="mr-2 mb-1"
                                :color="idx === 0 ? 'error' : 'primary'"
                                dark
                                close
                                @click:close="toggleCompareSelect(sel)"
                            >
                                {{ compareSlotLabel(idx) }} · v{{ sel.versao }}
                            </v-chip>
                            <v-btn
                                v-if="compareSelection.length"
                                text
                                x-small
                                class="mb-1"
                                @click="clearCompareSelection"
                            >
                                {{ $t('routingHistoryTimeline.compare.clear') }}
                            </v-btn>
                        </div>
                        <v-timeline dense clipped>
                            <v-timeline-item
                                v-for="row in detailRows"
                                :key="row.id_historico_roteirizacao"
                                :color="timelineColor(row.tipo_evento)"
                                small
                            >
                                <v-card
                                    outlined
                                    class="pa-3 historico-timeline-card"
                                    :class="{
                                        'historico-timeline-card--compare-a': compareSlot(row) === 0,
                                        'historico-timeline-card--compare-b': compareSlot(row) === 1,
                                    }"
                                >
                                    <div class="d-flex align-center flex-wrap mb-1">
                                        <v-checkbox
                                            v-if="!isPassengerRegistryEvent(row)"
                                            :input-value="isCompareSelected(row)"
                                            :disabled="!isCompareSelected(row) && compareSelection.length >= 2"
                                            dense
                                            hide-details
                                            class="mt-0 pt-0 mr-1 historico-compare-check"
                                            :color="compareSlot(row) === 0 ? 'error' : 'primary'"
                                            @click.stop.prevent="toggleCompareSelect(row)"
                                        />
                                        <v-chip
                                            v-if="compareSlot(row) != null"
                                            x-small
                                            label
                                            dark
                                            class="mr-2"
                                            :color="compareSlot(row) === 0 ? 'error' : 'primary'"
                                        >
                                            {{ compareSlotLabel(compareSlot(row)) }}
                                        </v-chip>
                                        <v-chip
                                            x-small
                                            label
                                            :color="timelineColor(row.tipo_evento)"
                                            dark
                                            class="mr-2"
                                        >
                                            {{ tipoEventoLabel(row.tipo_evento) }}
                                        </v-chip>
                                        <span class="text-caption text--secondary">
                                            <template v-if="row.versao != null">
                                                {{ $t('routingHistoryTimeline.versionLabel', { version: row.versao }) }} ·
                                            </template>
                                            {{ row.dt_calculo_extenso || formatDateTime(row.dt_calculo) }}
                                        </span>
                                        <v-spacer />
                                        <v-tooltip v-if="!isPassengerRegistryEvent(row)" top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    icon
                                                    x-small
                                                    color="primary"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :loading="openingHistoricoId === row.id_historico_roteirizacao"
                                                    @click.stop="openHistoricoInRoteirizacao(row)"
                                                >
                                                    <v-icon small>mdi-map-search</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>{{ $t('routingHistoryTimeline.openInRouting') }}</span>
                                        </v-tooltip>
                                    </div>
                                    <div class="text-body-2 font-weight-medium mb-1">
                                        {{ row.titulo || '—' }}
                                    </div>
                                    <div v-if="detalheResumo(row)" class="text-body-2 mb-2">
                                        {{ detalheResumo(row) }}
                                    </div>
                                    <v-expansion-panels
                                        v-if="isPassengerRegistryEvent(row) && passengerRegistryPeople(row).length"
                                        accordion
                                        flat
                                        class="mb-2"
                                    >
                                        <v-expansion-panel>
                                            <v-expansion-panel-header>
                                                {{ $t('routingHistoryTimeline.passengerRegistry.peopleCount', {
                                                    count: passengerRegistryPeople(row).length,
                                                }) }}
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <div class="historico-passageiros-registro-table-wrap">
                                                    <table class="historico-passageiros-registro-table">
                                                        <thead>
                                                            <tr>
                                                                <th>{{ $t('routingHistoryTimeline.people.registration') }}</th>
                                                                <th>{{ $t('routingHistoryTimeline.people.name') }}</th>
                                                                <th>{{ $t('routingHistoryTimeline.passengerRegistry.outboundLine') }}</th>
                                                                <th>{{ $t('routingHistoryTimeline.passengerRegistry.returnLine') }}</th>
                                                                <th>{{ $t('routingHistoryTimeline.passengerRegistry.result') }}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                v-for="(person, personIndex) in passengerRegistryPeople(row)"
                                                                :key="`${row.id_historico_roteirizacao}-${person.id_pessoa || personIndex}`"
                                                            >
                                                                <td>{{ person.matricula || '—' }}</td>
                                                                <td>{{ person.nome_pessoa || '—' }}</td>
                                                                <td>{{ passengerRegistryLine(person, 'ida') }}</td>
                                                                <td>{{ passengerRegistryLine(person, 'volta') }}</td>
                                                                <td>{{ passengerRegistryResultLabel(person.resultado) }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                    <div v-if="!isPassengerRegistryEvent(row)" class="d-flex flex-wrap">
                                        <v-chip x-small outlined class="mr-1 mb-1">
                                            {{ formatKm(row.km_total) }}
                                        </v-chip>
                                        <v-chip x-small outlined class="mr-1 mb-1">
                                            {{ formatMoney(row.custo_total) }}
                                        </v-chip>
                                        <v-chip v-if="row.qtd_motoristas != null" x-small outlined class="mr-1 mb-1">
                                            {{ $t('routingHistoryTimeline.driversChip', { count: row.qtd_motoristas }) }}
                                            · {{ formatMoney(row.custo_motoristas_total) }}
                                        </v-chip>
                                        <v-chip x-small outlined class="mr-1 mb-1">
                                            {{ $t('routingHistoryTimeline.routesChip', { count: row.qtd_rotas_operacionais || 0 }) }}
                                        </v-chip>
                                        <v-chip x-small outlined class="mb-1">
                                            {{ $t('routingHistoryTimeline.stopsChip', { count: row.qtd_paradas || 0 }) }}
                                        </v-chip>
                                    </div>
                                </v-card>
                            </v-timeline-item>
                        </v-timeline>
                    </template>
                </v-card-text>
                <v-card-text v-if="!isPassengerRegistrySession" v-show="detailTab === 1">
                    <v-progress-linear v-if="peopleLoading" indeterminate class="mb-4" />
                    <div v-else-if="!peopleTimeline.length" class="text-body-2 text--secondary pa-3">
                        {{ $t('routingHistoryTimeline.people.empty') }}
                    </div>
                    <v-timeline v-else dense clipped>
                        <v-timeline-item
                            v-for="version in peopleTimeline"
                            :key="version.id_historico_roteirizacao"
                            color="primary"
                            small
                        >
                            <v-card outlined class="pa-3 historico-timeline-card">
                                <div class="d-flex align-center flex-wrap mb-2">
                                    <span class="text-caption text--secondary">
                                        {{ version.dt_calculo_extenso || formatDateTime(version.dt_calculo) }}
                                        · {{ version.nome_usuario || $t('routingHistoryTimeline.people.user', { id: version.id_usuario }) }}
                                    </span>
                                </div>
                                <div class="d-flex flex-wrap mb-2">
                                    <v-chip
                                        v-for="total in version.totals"
                                        :key="total.tipo_evento"
                                        x-small
                                        outlined
                                        class="mr-1 mb-1"
                                        :color="peopleEventColor(total.tipo_evento)"
                                    >
                                        {{ peopleEventLabel(total.tipo_evento) }}: {{ total.count }}
                                    </v-chip>
                                </div>
                                <v-expansion-panels accordion flat>
                                    <v-expansion-panel
                                        v-for="group in version.groups"
                                        :key="group.key"
                                        @change="loadPeopleGroupDetails(group)"
                                    >
                                        <v-expansion-panel-header>
                                            <div class="d-flex align-center">
                                                <v-chip
                                                    x-small
                                                    label
                                                    dark
                                                    class="mr-2"
                                                    :color="peopleEventColor(group.tipo_evento)"
                                                >
                                                    {{ peopleEventLabel(group.tipo_evento) }}
                                                </v-chip>
                                                <span>{{ peopleGroupSummary(group) }}</span>
                                            </div>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-progress-linear v-if="group.loading" indeterminate />
                                            <v-simple-table v-else dense>
                                                <thead><tr>
                                                    <th>{{ $t('routingHistoryTimeline.people.registration') }}</th>
                                                    <th>{{ $t('routingHistoryTimeline.people.name') }}</th>
                                                    <th>{{ $t('routingHistoryTimeline.people.origin') }}</th>
                                                    <th>{{ $t('routingHistoryTimeline.people.destination') }}</th>
                                                </tr></thead>
                                                <tbody><tr v-for="person in group.details" :key="person.id_evento">
                                                    <td>{{ person.matricula || '—' }}</td>
                                                    <td>{{ person.nome_pessoa || person.id_pessoa }}</td>
                                                    <td>{{ peopleEventPlace(person, 'anterior') }}</td>
                                                    <td>{{ peopleEventPlace(person, 'atual') }}</td>
                                                </tr></tbody>
                                            </v-simple-table>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-card>
                        </v-timeline-item>
                    </v-timeline>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="compareShow" max-width="1100" scrollable>
            <v-card v-if="compareShow">
                <v-card-title>
                    {{ $t('routingHistoryTimeline.compare.title') }}
                    <v-spacer />
                    <v-btn icon @click="closeCompare"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-progress-linear v-if="compareLoading" indeterminate class="mb-4" />
                    <template v-else-if="compareA && compareB">
                        <v-row class="mb-4">
                            <v-col cols="12" md="4">
                                <v-card outlined class="pa-4 fill-height">
                                    <div class="text-subtitle-1 font-weight-bold error--text mb-2">
                                        {{ $t('routingHistoryTimeline.compare.versionA') }}
                                    </div>
                                    <div class="text-caption mb-2">
                                        {{ tipoEventoLabel(compareA.tipo_evento) }}
                                        · {{ $t('routingHistoryTimeline.versionLabel', { version: compareA.versao }) }}
                                    </div>
                                    <div class="text-caption mb-3">
                                        {{ compareA.dt_calculo_extenso || formatDateTime(compareA.dt_calculo) }}
                                    </div>
                                    <div>{{ $t('routingHistoryTimeline.headers.km') }}: {{ formatKm(compareA.km_total) }}</div>
                                    <div>{{ $t('routingHistoryTimeline.headers.cost') }}: {{ formatMoney(compareA.custo_total) }}</div>
                                    <div v-if="compareA.qtd_motoristas != null">{{ $t('routingHistoryTimeline.headers.drivers') }}: {{ compareA.qtd_motoristas }}</div>
                                    <div v-if="compareA.custo_motoristas_total != null">{{ $t('routingHistoryTimeline.headers.driversCost') }}: {{ formatMoney(compareA.custo_motoristas_total) }}</div>
                                    <div>{{ $t('routingHistoryTimeline.headers.routes') }}: {{ compareA.qtd_rotas_operacionais || 0 }}</div>
                                    <div>{{ $t('routingHistoryTimeline.compare.stops') }}: {{ compareA.qtd_paradas || 0 }}</div>
                                    <div>{{ $t('routingHistoryTimeline.compare.passengers') }}: {{ compareA.passageiros_total || 0 }}</div>
                                </v-card>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-card outlined class="pa-4 fill-height">
                                    <div class="text-subtitle-1 font-weight-bold mb-2">
                                        {{ $t('routingHistoryTimeline.compare.delta') }}
                                    </div>
                                    <div class="mb-1">
                                        {{ $t('routingHistoryTimeline.headers.km') }}:
                                        <span :class="deltaClass(compareDelta.km)">{{ formatKmDelta(compareDelta.km) }}</span>
                                    </div>
                                    <div class="mb-1">
                                        {{ $t('routingHistoryTimeline.headers.cost') }}:
                                        <span :class="deltaClass(compareDelta.custo)">{{ formatMoneyDelta(compareDelta.custo) }}</span>
                                    </div>
                                    <div v-if="compareDelta.motoristas != null" class="mb-1">
                                        {{ $t('routingHistoryTimeline.headers.drivers') }}:
                                        <span :class="deltaClass(compareDelta.motoristas)">{{ formatIntDelta(compareDelta.motoristas) }}</span>
                                    </div>
                                    <div v-if="compareDelta.custoMotoristas != null" class="mb-1">
                                        {{ $t('routingHistoryTimeline.headers.driversCost') }}:
                                        <span :class="deltaClass(compareDelta.custoMotoristas)">{{ formatMoneyDelta(compareDelta.custoMotoristas) }}</span>
                                    </div>
                                    <div class="mb-1">
                                        {{ $t('routingHistoryTimeline.headers.routes') }}:
                                        <span :class="deltaClass(compareDelta.rotas)">{{ formatIntDelta(compareDelta.rotas) }}</span>
                                    </div>
                                    <div class="mb-1">
                                        {{ $t('routingHistoryTimeline.compare.stops') }}:
                                        <span :class="deltaClass(compareDelta.paradas)">{{ formatIntDelta(compareDelta.paradas) }}</span>
                                    </div>
                                    <div>
                                        {{ $t('routingHistoryTimeline.compare.passengers') }}:
                                        <span :class="deltaClass(compareDelta.passageiros)">{{ formatIntDelta(compareDelta.passageiros) }}</span>
                                    </div>
                                    <v-divider class="my-3" />
                                    <div class="text-caption text--secondary">
                                        {{ $t('routingHistoryTimeline.compare.deltaHint') }}
                                    </div>
                                </v-card>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-card outlined class="pa-4 fill-height">
                                    <div class="text-subtitle-1 font-weight-bold primary--text mb-2">
                                        {{ $t('routingHistoryTimeline.compare.versionB') }}
                                    </div>
                                    <div class="text-caption mb-2">
                                        {{ tipoEventoLabel(compareB.tipo_evento) }}
                                        · {{ $t('routingHistoryTimeline.versionLabel', { version: compareB.versao }) }}
                                    </div>
                                    <div class="text-caption mb-3">
                                        {{ compareB.dt_calculo_extenso || formatDateTime(compareB.dt_calculo) }}
                                    </div>
                                    <div>{{ $t('routingHistoryTimeline.headers.km') }}: {{ formatKm(compareB.km_total) }}</div>
                                    <div>{{ $t('routingHistoryTimeline.headers.cost') }}: {{ formatMoney(compareB.custo_total) }}</div>
                                    <div v-if="compareB.qtd_motoristas != null">{{ $t('routingHistoryTimeline.headers.drivers') }}: {{ compareB.qtd_motoristas }}</div>
                                    <div v-if="compareB.custo_motoristas_total != null">{{ $t('routingHistoryTimeline.headers.driversCost') }}: {{ formatMoney(compareB.custo_motoristas_total) }}</div>
                                    <div>{{ $t('routingHistoryTimeline.headers.routes') }}: {{ compareB.qtd_rotas_operacionais || 0 }}</div>
                                    <div>{{ $t('routingHistoryTimeline.compare.stops') }}: {{ compareB.qtd_paradas || 0 }}</div>
                                    <div>{{ $t('routingHistoryTimeline.compare.passengers') }}: {{ compareB.passageiros_total || 0 }}</div>
                                </v-card>
                            </v-col>
                        </v-row>

                        <div class="text-subtitle-2 mb-2">{{ $t('routingHistoryTimeline.compare.mapTitle') }}</div>
                        <div class="d-flex align-center flex-wrap mb-2">
                            <v-checkbox
                                v-model="showLayerA"
                                dense
                                hide-details
                                class="mt-0 pt-0 mr-4"
                                :label="$t('routingHistoryTimeline.compare.versionA')"
                                color="error"
                            />
                            <v-checkbox
                                v-model="showLayerB"
                                dense
                                hide-details
                                class="mt-0 pt-0"
                                :label="$t('routingHistoryTimeline.compare.versionB')"
                                color="primary"
                            />
                        </div>
                        <div v-if="!hasCompareMapGeometry" class="text-body-2 text--secondary mb-2">
                            {{ $t('routingHistoryTimeline.compare.mapEmpty') }}
                        </div>
                        <div class="historico-compare-map">
                            <l-map
                                :key="compareMapKey"
                                :zoom="compareZoom"
                                :center="compareCenter"
                                :options="mapOptions"
                                style="height: 420px; width: 100%;"
                                @ready="onCompareMapReady"
                            >
                                <l-tile-layer :url="tileUrl" :attribution="tileAttribution" />
                                <l-geo-json
                                    v-if="showLayerA && geojsonA"
                                    :geojson="geojsonA"
                                    :options="styleOptionsA"
                                />
                                <l-geo-json
                                    v-if="showLayerB && geojsonB"
                                    :geojson="geojsonB"
                                    :options="styleOptionsB"
                                />
                            </l-map>
                        </div>

                        <div class="d-flex justify-end mt-4">
                            <v-btn
                                text
                                color="error"
                                class="mr-2"
                                @click="openHistoricoInRoteirizacao(compareA)"
                            >
                                {{ $t('routingHistoryTimeline.compare.openA') }}
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="openHistoricoInRoteirizacao(compareB)"
                            >
                                {{ $t('routingHistoryTimeline.compare.openB') }}
                            </v-btn>
                        </div>
                    </template>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { LMap, LTileLayer, LGeoJson } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import MerusDataTable from '@/components/Tables/MerusDataTable.vue';
import CadastroToolbar from '@/components/Toolbars/CadastroToolbar.vue';
import DateUtils from '@/utils/dateutils';
import {
    buildRequestParams,
    computePageState,
    fetchAllServerPagesForExport,
    initSortFromDefault,
    samePageAndSort,
} from '@/utils/serverTablePagination';

const COLOR_A = '#C62828';
const COLOR_B = '#1565C0';

export default {
    name: 'RELHistoricoRoteirizacao',
    components: {
        MerusDataTable,
        CadastroToolbar,
        LMap,
        LTileLayer,
        LGeoJson,
    },
    data: () => ({
        headers: [],
        user: null,
        token: null,
        formValidado: false,
        items: [],
        totalItems: 0,
        numberOfRows: 10,
        itemsPerPageLastOption: 1000,
        lastItemsPerPageBeforeTodos: null,
        pageNumber: 1,
        serverSortBy: [],
        serverSortDesc: [],
        columnFilters: {},
        reportRequestId: 0,
        destinationFilterTimer: null,
        loading: false,
        dti: null,
        dtf: null,
        nomeDestinoFiltro: null,
        timeProps: { useSeconds: true },
        detailShow: false,
        detailLoading: false,
        detailRows: [],
        detailTab: 0,
        peopleLoading: false,
        peopleLoaded: false,
        peopleGroups: [],
        selectedSession: null,
        openingHistoricoId: null,
        compareSelection: [],
        compareShow: false,
        compareLoading: false,
        compareA: null,
        compareB: null,
        compareRecordCache: {},
        geojsonA: null,
        geojsonB: null,
        showLayerA: true,
        showLayerB: true,
        compareMapKey: 0,
        compareMap: null,
        compareZoom: 13,
        compareCenter: [-22.88746, -43.29185],
        mapOptions: { zoomSnap: 0.5 },
        tileUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        tileAttribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        styleOptionsA: {
            style: () => ({
                color: COLOR_A,
                weight: 4,
                opacity: 0.9,
                dashArray: '12 16',
            }),
        },
        styleOptionsB: {
            style: () => ({
                color: COLOR_B,
                weight: 5,
                opacity: 0.95,
            }),
        },
    }),
    computed: {
        defaultSort() {
            return [
                { value: 'dt_fim', options: { text: this.$t('system.labels.decreasing'), value: -1 } },
            ];
        },
        defaultHeaders() {
            const col = (key, value, extra = {}) => ({
                text: this.$t(`routingHistoryTimeline.headers.${key}`),
                value,
                sortable: true,
                filtrable: true,
                show: true,
                ...extra,
            });
            return [
                col('destination', 'nome_destino'),
                col('startedAt', 'dt_inicio_extenso'),
                col('endedAt', 'dt_fim_extenso'),
                col('eventCount', 'qtd_eventos', { align: 'end' }),
                col('lastEventType', 'ultimo_tipo_evento_extenso'),
                col('lastVersion', 'ultima_versao', { align: 'end' }),
                col('km', 'km_total', { align: 'end', filtrable: false }),
                col('cost', 'custo_total', { align: 'end', filtrable: false }),
                col('drivers', 'qtd_motoristas', { align: 'end', sortable: false, filtrable: false }),
                col('driversCost', 'custo_motoristas_total', { align: 'end', sortable: false, filtrable: false }),
                col('routes', 'qtd_rotas_operacionais', { align: 'end' }),
                {
                    text: this.$t('routingHistoryTimeline.headers.actions'),
                    value: 'actions',
                    sortable: false,
                    filtrable: false,
                    show: true,
                    align: 'center',
                },
            ];
        },
        tableHeaders() {
            return this.headers.length > 0 ? this.headers : this.defaultHeaders;
        },
        textFieldProps() {
            return { prependInnerIcon: 'mdi-calendar' };
        },
        today() {
            return new Date().toISOString().substring(0, 10);
        },
        dtiProps() {
            return {
                max: this.dtf
                    ? (typeof DateUtils.getDateSQLFormatted === 'function'
                        ? String(DateUtils.getDateSQLFormatted(this.dtf)).slice(0, 10)
                        : this.today)
                    : this.today,
            };
        },
        dtfProps() {
            return {
                min: this.dti
                    ? (typeof DateUtils.getDateSQLFormatted === 'function'
                        ? String(DateUtils.getDateSQLFormatted(this.dti)).slice(0, 10)
                        : undefined)
                    : undefined,
                max: this.today,
            };
        },
        compareDelta() {
            const a = this.compareA || {};
            const b = this.compareB || {};
            const num = (v) => {
                const n = Number(v);
                return Number.isFinite(n) ? n : null;
            };
            const diff = (x, y) => {
                if (x == null || y == null) return null;
                return y - x;
            };
            return {
                km: diff(num(a.km_total), num(b.km_total)),
                custo: diff(num(a.custo_total), num(b.custo_total)),
                motoristas: diff(num(a.qtd_motoristas), num(b.qtd_motoristas)),
                custoMotoristas: diff(num(a.custo_motoristas_total), num(b.custo_motoristas_total)),
                rotas: diff(num(a.qtd_rotas_operacionais), num(b.qtd_rotas_operacionais)),
                paradas: diff(num(a.qtd_paradas), num(b.qtd_paradas)),
                passageiros: diff(num(a.passageiros_total), num(b.passageiros_total)),
            };
        },
        hasCompareMapGeometry() {
            return !!(this.geojsonA || this.geojsonB);
        },
        isPassengerRegistrySession() {
            if (this.detailRows.some((row) => this.isPassengerRegistryEvent(row))) return true;
            return String(this.selectedSession && this.selectedSession.ultimo_tipo_evento || '').toUpperCase()
                === 'CADASTRO_PESSOAS';
        },
        peopleTimeline() {
            const versions = new Map();
            this.peopleGroups.forEach((group) => {
                const key = String(group.id_historico_roteirizacao);
                if (!versions.has(key)) {
                    versions.set(key, {
                        id_historico_roteirizacao: group.id_historico_roteirizacao,
                        versao: group.versao,
                        dt_calculo: group.dt_calculo,
                        dt_calculo_extenso: group.dt_calculo_extenso,
                        id_usuario: group.id_usuario,
                        nome_usuario: group.nome_usuario,
                        groups: [],
                        totals: [],
                        totalsByType: new Map(),
                    });
                }
                const version = versions.get(key);
                version.groups.push(group);
                if (!version.totalsByType.has(group.tipo_evento)) {
                    const total = {
                        tipo_evento: group.tipo_evento,
                        count: Number(group.total_tipo_pessoas || group.pessoas_distintas || 0),
                    };
                    version.totalsByType.set(group.tipo_evento, total);
                    version.totals.push(total);
                }
            });
            const timeline = Array.from(versions.values());
            timeline.forEach((version) => { delete version.totalsByType; });
            return timeline.sort((a, b) => {
                const timeA = a.dt_calculo ? new Date(a.dt_calculo).getTime() : 0;
                const timeB = b.dt_calculo ? new Date(b.dt_calculo).getTime() : 0;
                if (timeA !== timeB) return timeA - timeB;
                return Number(a.id_historico_roteirizacao || 0)
                    - Number(b.id_historico_roteirizacao || 0);
            });
        },
        peopleEventTotal() {
            return this.peopleTimeline.reduce((sum, version) => sum + version.totals.reduce(
                (versionSum, total) => versionSum + Number(total.count || 0), 0,
            ), 0);
        },
    },
    watch: {
        nomeDestinoFiltro() {
            if (this.destinationFilterTimer) clearTimeout(this.destinationFilterTimer);
            this.destinationFilterTimer = setTimeout(() => {
                this.pageNumber = 1;
                this.populaRelatorio();
            }, 350);
        },
        detailTab(value) {
            if (value === 1 && !this.peopleLoaded && this.selectedSession) {
                this.loadPeopleTimeline(this.selectedSession.id_sessao);
            }
        },
        compareShow(val) {
            if (!val) {
                this.compareMap = null;
            } else {
                this.$nextTick(() => this.fitCompareMap());
            }
        },
        showLayerA() {
            this.$nextTick(() => this.fitCompareMap());
        },
        showLayerB() {
            this.$nextTick(() => this.fitCompareMap());
        },
    },
    mounted() {
        this.user = JSON.parse(localStorage.getItem('user'));
        this.token = localStorage.getItem('token');
        const now = new Date();
        const start = new Date(now);
        start.setDate(start.getDate() - 30);
        this.dti = start;
        this.dtf = now;
        const initialSort = initSortFromDefault(this.defaultSort);
        this.serverSortBy = initialSort.serverSortBy;
        this.serverSortDesc = initialSort.serverSortDesc;
        this.populaRelatorio();
    },
    beforeDestroy() {
        if (this.destinationFilterTimer) clearTimeout(this.destinationFilterTimer);
        this.reportRequestId += 1;
    },
    methods: {
        timelineColor(tipo) {
            const t = String(tipo || '').toUpperCase();
            if (t === 'GERADA') return 'primary';
            if (t === 'MANUAL') return 'info';
            if (t === 'CADASTRO_PESSOAS') return 'indigo';
            if (t === 'EDITADA_ROTA' || t === 'EDITADA_PARADA' || t === 'EDITADA_SWAP') return 'warning';
            return 'grey';
        },
        isPassengerRegistryEvent(row) {
            return String(row && row.tipo_evento || '').toUpperCase() === 'CADASTRO_PESSOAS';
        },
        passengerRegistryPeople(row) {
            const detail = row && row.detalhe_json;
            return detail && Array.isArray(detail.pessoas) ? detail.pessoas : [];
        },
        passengerRegistryLine(person, direction) {
            if (!person) return '—';
            return person[`cod_linha_${direction}`] || person[`id_linha_${direction}`] || '—';
        },
        passengerRegistryResultLabel(result) {
            if (!result) return '—';
            const key = String(result).toUpperCase();
            const path = `routingHistoryTimeline.passengerRegistry.results.${key}`;
            const label = this.$t(path);
            return label === path ? result : label;
        },
        peopleEventColor(tipo) {
            return {
                ADICIONADA: 'success',
                REMOVIDA: 'error',
                MOVIDA: 'primary',
                PARADA_ALTERADA: 'warning',
            }[String(tipo || '').toUpperCase()] || 'grey';
        },
        peopleEventLabel(tipo) {
            return this.$t(`routingHistoryTimeline.people.eventTypes.${String(tipo || '').toUpperCase()}`);
        },
        peoplePlaceLabel(row, suffix) {
            const line = row[`cod_linha_${suffix}`] || row[`nome_linha_${suffix}`]
                || row[`id_linha_${suffix}`] || '—';
            const route = row[`cod_rota_${suffix}`] || row[`nome_rota_${suffix}`]
                || row[`id_rota_${suffix}`] || '—';
            return this.$t('routingHistoryTimeline.people.place', { line, route });
        },
        peopleEventPlace(row, suffix) {
            if (row[`id_linha_${suffix}`] == null && row[`id_rota_${suffix}`] == null) return '—';
            const boarding = row[`id_cerca_embarque_${suffix}`];
            const alighting = row[`id_cerca_desembarque_${suffix}`];
            const fences = [boarding, alighting].filter((value) => value != null).join(' / ');
            return fences
                ? `${this.peoplePlaceLabel(row, suffix)} · ${this.$t('routingHistoryTimeline.people.fences', { fences })}`
                : this.peoplePlaceLabel(row, suffix);
        },
        peopleGroupSummary(group) {
            const count = Number(group.pessoas_distintas || group.quantidade || 0);
            const direction = this.$t(`routingHistoryTimeline.people.directions.${Number(group.sentido) === 2 ? 'return' : 'outbound'}`);
            const params = {
                count,
                direction,
                origin: this.peoplePlaceLabel(group, 'anterior'),
                destination: this.peoplePlaceLabel(group, 'atual'),
            };
            return this.$t(`routingHistoryTimeline.people.summaries.${group.tipo_evento}`, params);
        },
        peopleGroupQuery(group) {
            const query = {
                id_historico_roteirizacao: group.id_historico_roteirizacao,
                tipo_evento: group.tipo_evento,
                sentido: group.sentido,
            };
            ['id_linha_anterior', 'id_rota_anterior', 'id_linha_atual', 'id_rota_atual'].forEach((key) => {
                if (group[key] != null) query[key] = group[key];
            });
            return query;
        },
        async loadPeopleGroupDetails(group) {
            if (!group || group.loaded || group.loading) return;
            this.$set(group, 'loading', true);
            try {
                const groupQuery = this.peopleGroupQuery(group);
                const res = await apiController.request(
                    apiController.endpoints.getHistoricoroteirizacaopessoaseventosdetalhes,
                    {
                        query: {
                            id_historico_roteirizacao: groupQuery.id_historico_roteirizacao,
                            tipo_evento: groupQuery.tipo_evento,
                            sentido: groupQuery.sentido,
                            id_linha_anterior: groupQuery.id_linha_anterior,
                            id_rota_anterior: groupQuery.id_rota_anterior,
                            id_linha_atual: groupQuery.id_linha_atual,
                            id_rota_atual: groupQuery.id_rota_atual,
                        },
                        silent: true,
                    },
                );
                this.$set(group, 'details', Array.isArray(res.data) ? res.data : []);
                this.$set(group, 'loaded', true);
            } catch (e) {
                EventBus.$emit('show-error', { error: e });
            } finally {
                this.$set(group, 'loading', false);
            }
        },
        async loadPeopleTimeline(idSessao) {
            this.peopleLoading = true;
            this.peopleLoaded = false;
            this.peopleGroups = [];
            try {
                const res = await apiController.request(
                    apiController.endpoints.getHistoricoroteirizacaopessoaseventos,
                    { query: { id_sessao: idSessao }, silent: true },
                );
                this.peopleGroups = (Array.isArray(res.data) ? res.data : []).map((row, index) => ({
                    ...row,
                    key: `${row.id_historico_roteirizacao}-${row.tipo_evento}-${row.sentido}-${index}`,
                    details: [],
                    loading: false,
                    loaded: false,
                }));
                this.peopleLoaded = true;
            } catch (e) {
                this.peopleGroups = [];
                EventBus.$emit('show-error', { error: e });
            } finally {
                this.peopleLoading = false;
            }
        },
        tipoEventoLabel(tipo) {
            const key = String(tipo || 'MANUAL').toUpperCase();
            const path = `routingHistoryTimeline.eventTypes.${key}`;
            const label = this.$t(path);
            if (label !== path) return label;
            const fallback = this.$t(`routePlanning.dialogs.historico.eventTypes.${key}`);
            return fallback === `routePlanning.dialogs.historico.eventTypes.${key}` ? key : fallback;
        },
        formatKm(v) {
            const n = Number(v);
            return Number.isFinite(n) ? `${n.toFixed(2)} km` : '—';
        },
        formatMoney(v) {
            const n = Number(v);
            if (!Number.isFinite(n)) return '—';
            return n.toLocaleString(this.$i18n.locale === 'es-MX' ? 'es-MX' : 'pt-BR', {
                style: 'currency',
                currency: 'BRL',
            });
        },
        formatDateTime(dt) {
            if (!dt) return '—';
            try {
                const d = new Date(dt);
                if (Number.isNaN(d.getTime())) return String(dt);
                return d.toLocaleString(this.$i18n.locale === 'es-MX' ? 'es-MX' : 'pt-BR');
            } catch (e) {
                return String(dt);
            }
        },
        formatKmDelta(v) {
            if (v == null || !Number.isFinite(Number(v))) return '—';
            const n = Number(v);
            const sign = n > 0 ? '+' : '';
            return `${sign}${n.toFixed(2)} km`;
        },
        formatMoneyDelta(v) {
            if (v == null || !Number.isFinite(Number(v))) return '—';
            const n = Number(v);
            const formatted = Math.abs(n).toLocaleString(
                this.$i18n.locale === 'es-MX' ? 'es-MX' : 'pt-BR',
                { style: 'currency', currency: 'BRL' },
            );
            if (n > 0) return `+${formatted}`;
            if (n < 0) return `-${formatted}`;
            return formatted;
        },
        formatIntDelta(v) {
            if (v == null || !Number.isFinite(Number(v))) return '—';
            const n = Number(v);
            const sign = n > 0 ? '+' : '';
            return `${sign}${n}`;
        },
        deltaClass(v) {
            if (v == null || !Number.isFinite(Number(v)) || Number(v) === 0) return '';
            return Number(v) > 0 ? 'error--text' : 'success--text';
        },
        toSqlDate(value) {
            if (!value) return null;
            if (typeof DateUtils.getDateSQLFormatted === 'function') {
                const raw = DateUtils.getDateSQLFormatted(value);
                return raw ? String(raw).slice(0, 10) : null;
            }
            const d = new Date(value);
            if (Number.isNaN(d.getTime())) return null;
            return d.toISOString().slice(0, 10);
        },
        mapSessionItem(row) {
            if (!row) return row;
            return {
                ...row,
                ultimo_tipo_evento_extenso: this.tipoEventoLabel(row.ultimo_tipo_evento),
            };
        },
        detalheResumo(row) {
            const d = row && row.detalhe_json;
            if (!d || typeof d !== 'object') return '';
            const tipo = String(row.tipo_evento || '').toUpperCase();
            if (tipo === 'CADASTRO_PESSOAS') {
                const actionPath = `routingHistoryTimeline.passengerRegistry.actions.${String(d.acao || '').toUpperCase()}`;
                const action = this.$t(actionPath);
                return this.$t('routingHistoryTimeline.passengerRegistry.summary', {
                    action: action === actionPath ? d.acao : action,
                    count: Number(d.quantidade || this.passengerRegistryPeople(row).length || 0),
                });
            }
            if (tipo === 'EDITADA_ROTA') {
                if (d.origem === 'CRUD_LINHAS' && d.acao === 'ROTEIRIZAR_POR_CERCAS') {
                    return this.$t('routingHistoryTimeline.detail.routeByFencesCrud', {
                        route: (d.rota_atual && (
                            d.rota_atual.nome_rota
                            || d.rota_atual.cod_rota
                            || d.rota_atual.id_rota
                        )) || '—',
                        line: d.cod_linha || d.nome_linha || d.id_linha || '—',
                    });
                }
                return this.$t('routingHistoryTimeline.detail.editRoute', {
                    route: d._rotaId != null ? d._rotaId : '—',
                    vias: d.vias != null ? d.vias : 0,
                });
            }
            if (tipo === 'EDITADA_PARADA') {
                if (d.origem === 'CRUD_LINHAS' && d.acao === 'EDITAR_CERCA') {
                    const cerca = d.cerca_atual || d.cerca_anterior || {};
                    return this.$t('routingHistoryTimeline.detail.editFenceCrud', {
                        fence: cerca.nome_cerca || cerca.cod_cerca || cerca.id_cerca || '—',
                        line: d.cod_linha || d.nome_linha || d.id_linha || '—',
                    });
                }
                if (d.origem === 'CRUD_LINHAS' && d.acao === 'EXCLUIR_CERCA') {
                    const cerca = d.cerca_anterior || {};
                    return this.$t('routingHistoryTimeline.detail.deleteFenceCrud', {
                        fence: cerca.nome_cerca || cerca.cod_cerca || cerca.id_cerca || '—',
                        line: d.cod_linha || d.nome_linha || d.id_linha || '—',
                    });
                }
                return this.$t('routingHistoryTimeline.detail.editStop', {
                    route: d._rotaId != null ? d._rotaId : '—',
                    stop: d.stopIdx != null ? Number(d.stopIdx) + 1 : '—',
                });
            }
            if (tipo === 'EDITADA_SWAP') {
                // Prefere o número visível da rota; registros antigos só têm o
                // identificador interno (_rotaId).
                const pickRoute = (numero, interno) => {
                    if (numero != null) return numero;
                    return interno != null ? interno : '—';
                };
                const source = pickRoute(d.source_routeNumber, d.source_rotaId);
                const target = pickRoute(d.target_routeNumber, d.target_rotaId);
                const stop = (d.stop && (d.stop.endereco || d.stop.id_cerca)) || null;
                const count = Number(d.passageiros);
                if (stop && Number.isFinite(count) && count > 0) {
                    return this.$t('routingHistoryTimeline.detail.swapStopDetailed', {
                        source, target, stop, count,
                    });
                }
                if (stop) {
                    return this.$t('routingHistoryTimeline.detail.swapStopWithStop', {
                        source, target, stop,
                    });
                }
                return this.$t('routingHistoryTimeline.detail.swapStop', { source, target });
            }
            return '';
        },
        isCompareSelected(row) {
            const id = row && row.id_historico_roteirizacao;
            return this.compareSelection.some((s) => s.id_historico_roteirizacao === id);
        },
        compareSlot(row) {
            const id = row && row.id_historico_roteirizacao;
            const idx = this.compareSelection.findIndex((s) => s.id_historico_roteirizacao === id);
            return idx >= 0 ? idx : null;
        },
        compareSlotLabel(idx) {
            return idx === 0
                ? this.$t('routingHistoryTimeline.compare.slotA')
                : this.$t('routingHistoryTimeline.compare.slotB');
        },
        toggleCompareSelect(row) {
            if (!row || row.id_historico_roteirizacao == null) return;
            const id = row.id_historico_roteirizacao;
            const idx = this.compareSelection.findIndex((s) => s.id_historico_roteirizacao === id);
            if (idx >= 0) {
                this.compareSelection.splice(idx, 1);
                return;
            }
            if (this.compareSelection.length >= 2) return;
            this.compareSelection.push(row);
        },
        clearCompareSelection() {
            this.compareSelection = [];
        },
        reportFilters() {
            return {
                dti: this.toSqlDate(this.dti),
                dtf: this.toSqlDate(this.dtf),
                nome_destino_busca: String(this.nomeDestinoFiltro || '').trim() || null,
                ...this.columnFilters,
            };
        },
        onTableOptions(options) {
            if (this.loading || !options) return;
            const state = {
                pageNumber: this.pageNumber,
                numberOfRows: this.numberOfRows,
                serverSortBy: this.serverSortBy,
                serverSortDesc: this.serverSortDesc,
            };
            if (!samePageAndSort(options, state)) this.loadReportPage(options);
        },
        onFiltersUpdate(filters) {
            const next = filters || {};
            if (JSON.stringify(next) === JSON.stringify(this.columnFilters)) return;
            this.columnFilters = next;
            this.pageNumber = 1;
            this.loadReportPage();
        },
        async loadReportPage(options) {
            const state = {
                pageNumber: this.pageNumber,
                numberOfRows: this.numberOfRows,
                serverSortBy: this.serverSortBy,
                serverSortDesc: this.serverSortDesc,
                searchFilters: this.reportFilters(),
                lastItemsPerPageBeforeTodos: this.lastItemsPerPageBeforeTodos,
                total: this.totalItems,
            };
            const request = buildRequestParams(options, state);
            const requestId = ++this.reportRequestId;
            this.loading = true;
            try {
                const res = await apiController.request(
                    apiController.endpoints.getHistoricoroteirizacaosessoes,
                    { query: request.params, silent: true },
                );
                if (requestId !== this.reportRequestId) return;
                const data = res.data && Array.isArray(res.data.items)
                    ? res.data : { items: Array.isArray(res.data) ? res.data : [], total: 0 };
                const rows = data.items;
                this.items = rows.map((row) => this.mapSessionItem(row));
                const updates = computePageState(data, request, state, this.itemsPerPageLastOption);
                this.totalItems = updates.total;
                this.pageNumber = updates.pageNumber;
                this.numberOfRows = updates.numberOfRows;
                this.lastItemsPerPageBeforeTodos = updates.lastItemsPerPageBeforeTodos;
                this.serverSortBy = updates.serverSortBy;
                this.serverSortDesc = updates.serverSortDesc;
            } catch (e) {
                if (requestId !== this.reportRequestId) return;
                this.items = [];
                this.totalItems = 0;
                EventBus.$emit('show-error', { error: e });
            } finally {
                if (requestId === this.reportRequestId) this.loading = false;
            }
        },
        populaRelatorio() {
            if (this.destinationFilterTimer) {
                clearTimeout(this.destinationFilterTimer);
                this.destinationFilterTimer = null;
            }
            this.pageNumber = 1;
            return this.loadReportPage();
        },
        loadItemsForExport(onProgress) {
            return fetchAllServerPagesForExport({
                fetchPage: async (params) => {
                    const response = await apiController.request(
                        apiController.endpoints.getHistoricoroteirizacaosessoes,
                        { query: params, silent: true },
                    );
                    return response.data;
                },
                state: {
                    total: this.totalItems,
                    serverSortBy: this.serverSortBy,
                    serverSortDesc: this.serverSortDesc,
                    searchFilters: this.reportFilters(),
                },
                onProgress,
                mapItems: (rows) => rows.map((row) => this.mapSessionItem(row)),
            });
        },
        async openDetail(item) {
            if (!item || !item.id_sessao) return;
            this.selectedSession = item;
            this.detailShow = true;
            this.detailLoading = true;
            this.detailRows = [];
            this.detailTab = 0;
            this.peopleGroups = [];
            this.peopleLoaded = false;
            this.clearCompareSelection();
            try {
                const res = await apiController.request(
                    apiController.endpoints.getHistoricoroteirizacaoporsessao,
                    { query: { id_sessao: item.id_sessao }, silent: true },
                );
                this.detailRows = (Array.isArray(res.data) ? res.data : [])
                    .filter((row) => String(row.tipo_evento || '').toUpperCase() !== 'EDITADA_PESSOAS');
            } catch (e) {
                this.detailRows = [];
                EventBus.$emit('show-error', { error: e });
            } finally {
                this.detailLoading = false;
            }
        },
        closeDetail() {
            this.detailShow = false;
            this.selectedSession = null;
            this.detailRows = [];
            this.peopleGroups = [];
            this.peopleLoaded = false;
            this.openingHistoricoId = null;
            this.clearCompareSelection();
        },
        openHistoricoInRoteirizacao(row) {
            const id = row && row.id_historico_roteirizacao != null
                ? Number(row.id_historico_roteirizacao)
                : NaN;
            if (!Number.isFinite(id) || id <= 0) return;
            this.openingHistoricoId = id;
            this.$router.push({
                name: 'Roteirizacao',
                query: {
                    modulo: 'roteirizacao',
                    historico: String(id),
                },
            }).catch(() => {
                this.openingHistoricoId = null;
            });
        },
        parseGeojson(raw) {
            if (!raw) return null;
            if (typeof raw === 'string') {
                try {
                    return JSON.parse(raw);
                } catch (e) {
                    return null;
                }
            }
            return raw;
        },
        buildRoutesFeatureCollection(record) {
            const routes = record && Array.isArray(record.rotas_json) ? record.rotas_json : [];
            const features = [];
            routes.forEach((route) => {
                if (!route || route._displacementLeg) return;
                const gj = this.parseGeojson(route.geojson);
                if (!gj) return;
                if (gj.type === 'FeatureCollection' && Array.isArray(gj.features)) {
                    gj.features.forEach((f) => {
                        if (f && f.geometry) features.push(f);
                    });
                    return;
                }
                if (gj.type === 'Feature' && gj.geometry) {
                    features.push(gj);
                    return;
                }
                if (gj.type && gj.coordinates) {
                    features.push({ type: 'Feature', properties: {}, geometry: gj });
                }
            });
            if (!features.length) return null;
            return { type: 'FeatureCollection', features };
        },
        async fetchHistoricoFull(id) {
            const cacheKey = String(id);
            if (this.compareRecordCache[cacheKey]) return this.compareRecordCache[cacheKey];
            const res = await apiController.request(
                apiController.endpoints.getHistoricoroteirizacaoporid,
                { params: { id }, query: { compare: 'true' }, silent: true },
            );
            if (res.data && res.data.erro) {
                throw new Error(res.data.mensagem || 'error');
            }
            this.$set(this.compareRecordCache, cacheKey, res.data);
            return res.data;
        },
        async openCompare() {
            if (this.compareSelection.length !== 2) return;
            const [aMeta, bMeta] = this.compareSelection;
            // Ordena cronologicamente: A = mais antiga, B = mais recente
            const ordered = [aMeta, bMeta].slice().sort((x, y) => {
                const tx = new Date(x.dt_calculo).getTime() || 0;
                const ty = new Date(y.dt_calculo).getTime() || 0;
                if (tx !== ty) return tx - ty;
                return Number(x.id_historico_roteirizacao) - Number(y.id_historico_roteirizacao);
            });
            this.compareLoading = true;
            this.compareShow = true;
            this.compareA = null;
            this.compareB = null;
            this.geojsonA = null;
            this.geojsonB = null;
            this.showLayerA = true;
            this.showLayerB = true;
            this.compareMapKey += 1;
            try {
                const [fullA, fullB] = await Promise.all([
                    this.fetchHistoricoFull(ordered[0].id_historico_roteirizacao),
                    this.fetchHistoricoFull(ordered[1].id_historico_roteirizacao),
                ]);
                this.compareA = { ...ordered[0], ...fullA };
                this.compareB = { ...ordered[1], ...fullB };
                this.geojsonA = this.buildRoutesFeatureCollection(this.compareA);
                this.geojsonB = this.buildRoutesFeatureCollection(this.compareB);
                this.$nextTick(() => this.fitCompareMap());
            } catch (e) {
                EventBus.$emit('show-alert', {
                    tipo: 'error',
                    mensagem: this.$t('routingHistoryTimeline.compare.loadError'),
                });
                this.compareShow = false;
            } finally {
                this.compareLoading = false;
            }
        },
        closeCompare() {
            this.compareShow = false;
            this.compareA = null;
            this.compareB = null;
            this.geojsonA = null;
            this.geojsonB = null;
            this.compareMap = null;
        },
        onCompareMapReady(mapObject) {
            this.compareMap = mapObject;
            this.$nextTick(() => this.fitCompareMap());
        },
        extendGeojsonBounds(geojson, bounds) {
            if (!geojson) return;
            const walk = (coords) => {
                if (!Array.isArray(coords)) return;
                if (typeof coords[0] === 'number' && typeof coords[1] === 'number') {
                    const lng = coords[0];
                    const lat = coords[1];
                    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
                    bounds.minLat = Math.min(bounds.minLat, lat);
                    bounds.maxLat = Math.max(bounds.maxLat, lat);
                    bounds.minLng = Math.min(bounds.minLng, lng);
                    bounds.maxLng = Math.max(bounds.maxLng, lng);
                    bounds.count += 1;
                    return;
                }
                coords.forEach(walk);
            };
            if (geojson.type === 'FeatureCollection') {
                (geojson.features || []).forEach((f) => {
                    if (f && f.geometry && f.geometry.coordinates) walk(f.geometry.coordinates);
                });
                return;
            }
            if (geojson.type === 'Feature' && geojson.geometry) {
                walk(geojson.geometry.coordinates);
                return;
            }
            if (geojson.coordinates) walk(geojson.coordinates);
        },
        fitCompareMap() {
            if (!this.compareMap || typeof this.compareMap.fitBounds !== 'function') return;
            const bounds = {
                minLat: Infinity,
                maxLat: -Infinity,
                minLng: Infinity,
                maxLng: -Infinity,
                count: 0,
            };
            if (this.showLayerA) this.extendGeojsonBounds(this.geojsonA, bounds);
            if (this.showLayerB) this.extendGeojsonBounds(this.geojsonB, bounds);
            if (bounds.count < 2) return;
            try {
                this.compareMap.fitBounds([
                    [bounds.minLat, bounds.minLng],
                    [bounds.maxLat, bounds.maxLng],
                ], { padding: [28, 28] });
            } catch (e) {
                // ignore invalid bounds
            }
        },
    },
};
</script>

<style scoped>
.historico-timeline-card {
    transition: box-shadow 0.15s ease, border-color 0.15s ease;
}
.historico-detalhe-card {
    height: 80vh;
    max-height: calc(100vh - 48px);
}
.historico-eventos-content {
    padding-top: 20px !important;
}
.historico-timeline-card--compare-a {
    border-color: #C62828 !important;
    box-shadow: 0 0 0 1px rgba(198, 40, 40, 0.25);
}
.historico-timeline-card--compare-b {
    border-color: #1565C0 !important;
    box-shadow: 0 0 0 1px rgba(21, 101, 192, 0.25);
}
.historico-compare-check {
    flex: 0 0 auto;
    max-width: 36px;
}
.historico-compare-map {
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    overflow: hidden;
}
.historico-passageiros-registro-table-wrap {
    max-height: 320px;
    overflow: auto;
}
.historico-passageiros-registro-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.75rem;
}
.historico-passageiros-registro-table th,
.historico-passageiros-registro-table td {
    padding: 6px 8px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    text-align: left;
    white-space: nowrap;
}
</style>
